export default {

    'modal': {
        namespaced: true,
        ...require('@/aplicacao/modulos/cartas-de-planejamento/_store').default,
    },

}
